import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'files',
            name: 'file',
            class: 'App\\Models\\File'
        }
    }
}